(function () {
  'use strict';

  // ============ CONFIG ============
  // SKUs der Trigger-Produkte (PBSerum Refine, Rebalance, Revive)
  var TRIGGER_SKUS = ['1500', '1510', '1520'];
  // SKU des Bundle-Produkts (PBSerum HA 2.0)
  var BUNDLE_SKU = '1501';
  // Handle des Bundle-Produkts in Shopify (URL-Handle, NICHT der Titel)
  // Stand 2026-05-05: pbserum-ha-2-1
  var BUNDLE_HANDLE = 'pbserum-ha-2-1';
  // Sections die nach Auto-Add neu gerendert werden sollen (Cart-Drawer + Cart-Icon)
  var REFRESH_SECTIONS = ['mini-cart', 'cart-icon-bubble', 'mobile-cart-icon-bubble'];
  // ================================

  var bundleVariantId = null;
  var syncing = false;
  var pendingTimer = null;

  function log() {
    if (window.__AUTO_ADD_BUNDLE_DEBUG) {
      console.log.apply(console, ['[AutoAddBundle]'].concat([].slice.call(arguments)));
    }
  }

  function isCartMutationUrl(url) {
    if (!url || typeof url !== 'string') return false;
    return /\/cart\/(add|change|update|clear)(\.js|$)/.test(url);
  }

  function getBundleVariantId() {
    if (bundleVariantId) return Promise.resolve(bundleVariantId);
    return fetch('/products/' + BUNDLE_HANDLE + '.js')
      .then(function (r) {
        if (!r.ok) throw new Error('Bundle product not found: ' + BUNDLE_HANDLE);
        return r.json();
      })
      .then(function (product) {
        bundleVariantId = product.variants[0].id;
        log('Bundle variant resolved:', bundleVariantId);
        return bundleVariantId;
      })
      .catch(function (err) {
        console.error('[AutoAddBundle] Could not load bundle product (Handle korrekt?):', err);
        return null;
      });
  }

  // Sammelt ALLE Bundle-Lines (nicht nur die erste) und summiert die Gesamt-Menge.
  // Notwendig weil Shopifys Discount-Allocation oder Apps die Bundle-Line splitten
  // koennen (z.B. 9 Stk discounted + 1 Stk regular = 2 separate Cart-Lines).
  function calculateState(cart) {
    var triggerQty = 0;
    var bundleItems = [];
    var totalBundleQty = 0;
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      if (TRIGGER_SKUS.indexOf(item.sku) !== -1) {
        triggerQty += item.quantity;
      } else if (item.sku === BUNDLE_SKU) {
        bundleItems.push(item);
        totalBundleQty += item.quantity;
      }
    }
    return { triggerQty: triggerQty, bundleItems: bundleItems, totalBundleQty: totalBundleQty };
  }

  function renderSections(parsedState) {
    if (!parsedState || !parsedState.sections) return;
    REFRESH_SECTIONS.forEach(function (sectionId) {
      var html = parsedState.sections[sectionId];
      var target = document.getElementById(sectionId);
      if (!html || !target) return;
      try {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newInner = doc.querySelector('.shopify-section');
        if (newInner) target.innerHTML = newInner.innerHTML;
      } catch (e) {
        log('Section render failed for ' + sectionId, e);
      }
    });
  }

  // Konsolidiert mehrere Bundle-Lines auf eine: alle ausser der ersten werden auf 0 gesetzt.
  // Liefert die erste Bundle-Line (oder null) zurueck nach Konsolidierung.
  function consolidateBundleLines(bundleItems) {
    if (bundleItems.length <= 1) return Promise.resolve(bundleItems[0] || null);
    log('Consolidating ' + bundleItems.length + ' bundle lines into one');
    var promises = [];
    for (var i = 1; i < bundleItems.length; i++) {
      promises.push(
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: bundleItems[i].key, quantity: 0 })
        })
      );
    }
    return Promise.all(promises).then(function () { return bundleItems[0]; });
  }

  function performSync() {
    if (syncing) return Promise.resolve();
    syncing = true;

    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var state = calculateState(cart);
        log('Pre-sync: triggerQty=' + state.triggerQty + ' totalBundleQty=' + state.totalBundleQty + ' bundleLines=' + state.bundleItems.length);

        // Schritt 1: Bundle-Lines konsolidieren falls mehrere vorhanden (Geister-Line-Bug)
        return consolidateBundleLines(state.bundleItems).then(function (firstLine) {
          // Schritt 2: nach Konsolidierung Cart neu lesen
          return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cartAfter) {
            var stateAfter = calculateState(cartAfter);
            var targetQty = stateAfter.triggerQty;
            var currentQty = stateAfter.totalBundleQty;

            log('Post-consolidation: targetQty=' + targetQty + ' currentBundleQty=' + currentQty);

            if (targetQty === currentQty) {
              // Bei reiner Konsolidierung Sections trotzdem refreshen
              if (state.bundleItems.length > 1) {
                return fetch('/cart.js?sections=' + REFRESH_SECTIONS.join(','))
                  .then(function (r) { return r.json(); });
              }
              return null;
            }

            if (currentQty === 0 && targetQty > 0) {
              return getBundleVariantId().then(function (variantId) {
                if (!variantId) return null;
                return fetch('/cart/add.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ id: variantId, quantity: targetQty, sections: REFRESH_SECTIONS })
                }).then(function (r) { return r.json(); });
              });
            }

            if (stateAfter.bundleItems.length > 0) {
              return fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: stateAfter.bundleItems[0].key, quantity: targetQty, sections: REFRESH_SECTIONS })
              }).then(function (r) { return r.json(); });
            }

            return null;
          });
        });
      })
      .then(function (mutationResult) {
        if (mutationResult) {
          renderSections(mutationResult);
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'auto-add-bundle', cart: mutationResult });
          }
        }
      })
      .catch(function (err) {
        console.error('[AutoAddBundle] Sync failed:', err);
      })
      .then(function () {
        // unlock after small delay to swallow recursive triggers from our own mutation
        setTimeout(function () { syncing = false; }, 200);
      });
  }

  function scheduleSync() {
    if (pendingTimer) clearTimeout(pendingTimer);
    pendingTimer = setTimeout(performSync, 100);
  }

  // Hook fetch
  if (window.fetch) {
    var origFetch = window.fetch;
    window.fetch = function () {
      var args = arguments;
      var url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url);
      var shouldSync = isCartMutationUrl(url) && !syncing;
      var promise = origFetch.apply(this, args);
      if (shouldSync) {
        promise.then(function () { scheduleSync(); }, function () {});
      }
      return promise;
    };
  }

  // Hook XMLHttpRequest
  var origOpen = XMLHttpRequest.prototype.open;
  var origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this._aab_url = url;
    return origOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    var self = this;
    if (isCartMutationUrl(self._aab_url) && !syncing) {
      self.addEventListener('load', function () { scheduleSync(); });
    }
    return origSend.apply(self, arguments);
  };

  // Initial sync on page load (deckt: User kommt mit gefuelltem Cart aus alter Session)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleSync);
  } else {
    scheduleSync();
  }
})();